var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verifyBody"},[_c('div',{staticClass:"verifyDiv"},[_c('div',{staticClass:"verify-content"},[_c('el-icon',{staticClass:"icon",attrs:{"name":"loading"}}),_c('h1',[_vm._v("正在重置密码")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }